import type { SymbolDefinition } from "../types.ts";

export const transformer: SymbolDefinition = {
  id: "ep-transformer",
  familyKey: "transformer",
  deviceKind: "transformer",
  version: "0.1.0",
  label: { sv: "Transformator", en: "Transformer" },
  description: { sv: "Två-lindad transformator.", en: "Two-winding transformer." },
  viewBox: "0 0 48 48",
  svg: `
    <g fill="none" stroke="currentColor" stroke-width="1.5">
      <circle cx="20" cy="24" r="8"/>
      <circle cx="28" cy="24" r="8"/>
      <line x1="8" y1="24" x2="12" y2="24"/>
      <line x1="36" y1="24" x2="40" y2="24"/>
    </g>
  `,
  terminals: [
    { id: "primary", kind: "phase", label: "L1", position: "left", offset: 0.5 },
    { id: "secondary", kind: "phase", label: "T1", position: "right", offset: 0.5 },
  ],
  designationPrefix: "T",
  searchKeywords: ["transformator", "transformer", "trafo"],
};
